import React from 'react';
import { useParams } from 'react-router-dom';
import { ProFormDatePicker, ProFormTextArea } from '@ant-design/pro-form';
import moment from 'moment';
import PropTypes from 'prop-types';
import ProForm from '../../../../layout/ProForm';
import { FormUpload } from '../../../../input';
import { PLACEHOLDER, WIDTH_2_COL } from 'constants/form';

const SubmitForm = ({
  initialValues,
  onFinish,
  withCustomDate,
  loading,
  disabled,
}) => {
  const { projectId } = useParams();
  return (
    <ProForm
      loading={loading}
      onFinish={onFinish}
      initialValues={initialValues}
      disabled={disabled}
    >
      <ProFormDatePicker
        label="Acutal Submission Date"
        name="actualSubmissionDate"
        width="xl"
        placeholder={PLACEHOLDER.PLEASE_SELECT}
        disabled={!withCustomDate}
        rules={
          withCustomDate
            ? [
                {
                  required: true,
                  message: 'Please enter acutal submission date!',
                },
              ]
            : []
        }
      />

      <FormUpload
        disabled={disabled}
        maxCount={1}
        name="reportFile"
        label="Report File"
        rules={[{ required: true, message: 'Please upload file!' }]}
        projectId={projectId}
        subFolder="REPORT_SUBMISSION"
      />
      <ProFormTextArea
        disabled={disabled}
        width={WIDTH_2_COL}
        name="remarks"
        label="Remarks"
        placeholder={PLACEHOLDER.PLEASE_ENTER}
      />
    </ProForm>
  );
};

SubmitForm.defaultProps = {
  withCustomDate: false,
  loading: true,
  initialValues: {
    actualSubmissionDate: moment(),
  },
};

SubmitForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  withCustomDate: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default SubmitForm;
